/**
 * Search API call — isolated for testability.
 */

import type { SearchResponse } from '@skjv/common';
import { fetchSearchResults } from '../../api/search';

interface SearchParams {
  text: string;
  isExact: boolean;
  limit: number;
  offset: number;
  testament?: number;
  bookNumber?: number;
}

/** Call the search API, returning empty on failure. */
export async function performSearch(params: SearchParams): Promise<SearchResponse> {
  try {
    return await fetchSearchResults(params);
  } catch (error) {
    console.error('Search failed:', error);
    return { results: [], total: 0, offset: params.offset, hasMore: false };
  }
}
